'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _EoApi = require('./../api/EoApi');

var _EoApi2 = _interopRequireDefault(_EoApi);

var _Utils = require('./../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro fulltextové hledání pracovníků.
 */
var PracovnikField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(PracovnikField, _AbstractReactCompone);

    function PracovnikField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PracovnikField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PracovnikField.__proto__ || (0, _getPrototypeOf2.default)(PracovnikField)).call.apply(_ref, [this].concat(args))), _this), _this.handleFilterSuggestions = function (value) {
            var proSpustenouAplikaci = _this.props.proSpustenouAplikaci;

            return _EoApi2.default.findPracovnici(value, proSpustenouAplikaci, 100);
        }, _this.renderPracovnik = function (i, active, getItemValue) {
            return _react2.default.createElement(
                'div',
                { className: active ? "active" : "" },
                i.uplneJmeno,
                i.organizacniJednotka && _react2.default.createElement(
                    'small',
                    null,
                    ' (',
                    i.organizacniJednotka.nazev,
                    ')'
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PracovnikField, [{
        key: 'render',
        value: function render() {
            var other = (0, _objectWithoutProperties3.default)(this.props, []);


            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                minCharsForFilter: 3,
                placeholder: 'Vyhledat pracovn\xEDka...',
                filterSuggestions: this.handleFilterSuggestions,
                getItemValue: function getItemValue(item) {
                    return item ? item.uplneJmeno : "";
                },
                renderSuggestion: this.renderPracovnik
            }, other));
        }
    }]);
    return PracovnikField;
}(_AbstractReactComponent2.default);

PracovnikField.PropTypes = {
    proSpustenouAplikaci: _react2.default.PropTypes.bool, // pokud je true, hledá jen mezi pracovníky aktuýálně spuštěné aplikace, jinak hledá mezi všemi pracovníky
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN,
    apiRequestDelay: _react2.default.PropTypes.number
};
PracovnikField.defaultProps = {
    apiRequestDelay: 250,
    proSpustenouAplikaci: true
};
exports.default = PracovnikField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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